
import { Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SidebarGroup, SidebarGroupLabel, SidebarGroupContent, SidebarMenu, SidebarMenuItem } from '@/components/ui/sidebar';
import { RecentBoardsProps } from './types';

export const RecentBoards = ({ boards, onBoardClick }: RecentBoardsProps) => {
  const { t } = useTranslation();

  return (
    <SidebarGroup className="mt-4">
      <div className="px-2 mb-2">
        <SidebarGroupLabel className="flex items-center gap-2">
          <Clock className="h-4 w-4" />
          {t('Recent Boards')}
        </SidebarGroupLabel>
      </div>
      <SidebarGroupContent>
        <SidebarMenu>
          {boards?.map((board) => (
            <SidebarMenuItem key={board.id}>
              <button
                onClick={(e) => onBoardClick(board.id, e)}
                className="flex items-center gap-2 w-full px-2 py-1.5 text-sm rounded-sm hover:bg-accent text-left"
              >
                {board.name}
              </button>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};
